/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Footer_LegalInputs */

const en_marketing_footer_legal = /** @type {(inputs: Marketing_Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

const es_marketing_footer_legal = /** @type {(inputs: Marketing_Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

const fr_marketing_footer_legal = /** @type {(inputs: Marketing_Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentions légales`)
};

/**
* | output |
* | --- |
* | "Legal" |
*
* @param {Marketing_Footer_LegalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_footer_legal = /** @type {((inputs?: Marketing_Footer_LegalInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Footer_LegalInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_footer_legal(inputs)
	if (locale === "es") return es_marketing_footer_legal(inputs)
	return fr_marketing_footer_legal(inputs)
});